import type { PropsWithChildren } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { ProfileResponse } from '@app/shared';
import { ConsentScreen } from './ConsentScreen';

/** While the server says consentRequired, every route shows the privacy notice. */
export function RequireConsent({ children }: PropsWithChildren) {
  const { data } = useQuery<ProfileResponse>({ queryKey: ['profile'], enabled: false });
  if (!data) return null;
  if (data.user.consentRequired) return <ConsentScreen />;
  return <>{children}</>;
}
